import type { TemplateSlot } from "../utils/derive-template";
import { ScheduleSlotCard } from "./ScheduleSlotCard";

interface ScheduleDayColumnProps {
  readonly dayLabel: string;
  readonly slots: readonly TemplateSlot[];
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot: () => void;
  readonly onContextMenu?: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleDayColumn({
  dayLabel,
  slots,
  onEditSlot,
  onAddSlot,
  onContextMenu,
}: ScheduleDayColumnProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between pb-2 border-b border-border">
        <h3 className="text-sm font-semibold text-ink-muted uppercase tracking-wide">
          {dayLabel}
          <span className="ml-2 text-ink-faint font-normal text-xs">
            {slots.length}
          </span>
        </h3>
        <button
          type="button"
          onClick={onAddSlot}
          className="min-w-7 h-7 flex items-center justify-center rounded-md border border-dashed border-border text-ink-muted hover:text-accent hover:border-accent transition-colors text-sm font-bold leading-none"
          title={`Ajouter un creneau le ${dayLabel}`}
        >
          +
        </button>
      </div>
      {slots.length === 0 && (
        <div className="text-xs text-ink-faint italic py-4 text-center">
          Aucun créneau
        </div>
      )}
      <div className="flex flex-col gap-1.5">
        {slots.map((slot) => (
          <ScheduleSlotCard
            key={slot.eventId}
            slot={slot}
            onEdit={onEditSlot}
            onContextMenu={onContextMenu}
          />
        ))}
      </div>
    </div>
  );
}
